<p>doc-functions-widget works!</p>
